import {useState} from "react";
import './contacts.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {connect} from "react-redux";
import {
    EmailIcon,
    FacebookWhiteIcon,
    InstagramWhiteIcon,
    PhoneIcon,
    TelegramWhiteIcon,
    YoutubeWhiteIcon
} from "../../assets/images";
import "./contacts.scss"
import {InputGroup} from "../../components/uiElements/inputGroup/InputGroup";
import isEmail from "validator/es/lib/isEmail";
import {SendContact} from "../../redux/actions";

const initData = {
    email: '',
    firstname: '',
    lastname: '',
    phone: '',
    message: '',
}
const initErrorData = {
    firstname: false,
    lastname: false,
    email: false,
    phone: false,
    message: false,
}
function Contacts(props) {
    const {contacts,staticTexts} = props;

    const [requestLoading, setRequestLoading] = useState(false);
    const [contact, setContact] = useState(initData);
    const [errors, setErrors] = useState(initErrorData);
    const getInputValues = (e) => {
        const {name, value} = e.target;
        setContact({
            ...contact,
            [name]: value
        })
        setErrors({
            ...errors,
            [name]: false
        })
    };
    function validate() {
        const errors = {};
        let result = true;
        Object.keys(contact).forEach(key => {
            if (!contact[key] || (key === 'email' && !isEmail(contact?.email))
            ) {
                errors[key] = true;
                result = false;
            }
        })
        setErrors(errors);
        return result;
    }
    async function sendMessage() {
        await setRequestLoading(true);

        if (validate()) {
            props.SendContact(contact).then(() => {
                setContact(initData);
                setErrors(initErrorData);
            }).catch(() => {

            }).finally(() => {
                setRequestLoading(false)
            })
        } else {
            setRequestLoading(false)
        }
    }

    return <div className={'contacts_wrapper'}>
        <div className={'contacts'}>
            <h2 className="contacts__title">{staticTexts?.contact_page_title}</h2>
            <h2 className="contacts__description">{staticTexts?.contact_page_description}</h2>
            <div className="contacts__content">
                <div className="contacts__info">
                    <div className="contacts__info__title">{staticTexts?.contact_page_inputs_title}</div>
                    <div className="contacts__info__description">{staticTexts?.contact_page_inputs_description}</div>
                    {contacts?.phoneNumber && <a href={`tel:${props?.contacts?.phoneNumber}`} className="contacts__info__item phone">
                        <PhoneIcon/> {contacts?.phoneNumber}
                    </a>}
                    {contacts?.email && <a href={`mailto:${props?.contacts?.email}`} className="contacts__info__item">
                        <EmailIcon/> {contacts?.email}
                    </a>}
                    <p className="contacts__info__social_text">
                        {staticTexts?.contact_page_social_text}
                    </p>
                    <div className="contacts__info__social_buttons">
                        {contacts?.facebook && <a className="social" href={contacts?.facebook} target={'_blank'}><FacebookWhiteIcon/></a>}
                        {contacts?.instagram && <a className="social" href={contacts?.instagram} target={'_blank'}><InstagramWhiteIcon/></a>}
                        {contacts?.telegram &&<a className="social" href={contacts?.telegram} target={'_blank'}><TelegramWhiteIcon/></a>}
                        {contacts?.youtube && <a className="social" href={contacts?.youtube} target={'_blank'}><YoutubeWhiteIcon/></a>}
                    </div>
                </div>
                <div className="contacts__form">
                    <div className="row">
                        <InputGroup
                            inputType={'input'}
                            type={"text"}
                            value={contact.firstname}
                            error={errors.firstname}
                            name={'firstname'}
                            placeholder={staticTexts?.contacts_page_placeholder_name}
                            label={staticTexts?.contacts_page_label_name}
                            maxLength={100}
                            onChange={getInputValues}
                        />
                        <InputGroup
                            inputType={'input'}
                            type={"text"}
                            value={contact.lastname}
                            error={errors.lastname}
                            name={'lastname'}
                            placeholder={staticTexts?.contacts_page_placeholder_lastName}
                            label={staticTexts?.contacts_page_label_lastName}
                            maxLength={100}
                            onChange={getInputValues}
                        />
                    </div>
                    <div className="row">
                        <InputGroup
                            inputType={'input'}
                            type={"text"}
                            value={contact.email}
                            error={errors.email}
                            name={'email'}
                            label={staticTexts?.contacts_page_label_email}
                            placeholder={staticTexts?.contacts_page_placeholder_email}
                            maxLength={100}
                            onChange={getInputValues}
                        />
                        <InputGroup
                            inputType={'input'}
                            type={"text"}
                            value={contact.phone}
                            error={errors.phone}
                            name={'phone'}
                            label={staticTexts?.contacts_page_label_phoneNumber}
                            placeholder={staticTexts?.contacts_page_placeholder_phoneNumber}
                            maxLength={100}
                            onChange={getInputValues}
                        />
                    </div>
                    <InputGroup
                        inputType={'input'}
                        type={"text"}
                        value={contact.message}
                        error={errors.message}
                        name={'message'}
                        label={staticTexts?.contacts_page_label_message}
                        placeholder={staticTexts?.contacts_page_placeholder_message}
                        maxLength={1000}
                        onChange={getInputValues}
                    />
                    <button className="send_btn" onClick={sendMessage}>{staticTexts?.contacts_page_btn_send}</button>
                </div>
            </div>
        </div>
    </div>
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'contacts',
        'staticTexts',
    ])
};
const mapDispatchToProps = {SendContact};
export default connect(mapStateToProps, mapDispatchToProps)(Contacts);
